export default "__VITE_ASSET__Bjjw6W3P__"